module.exports = __webpack_public_path__ + "static/media/news_kreka.be68ba8a.jpg";